function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import Modal from 'components/Modal';
import countrySettingsShape from 'shapes/countrySettingsShape';
import App from 'modules/App';
import Account from 'modules/Account';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import AddPatientForm from '../../partials/AddPatientForm';
import messages from '../../messages';
var _React_PureComponent;
class InvitePatientModal extends (_React_PureComponent = React.PureComponent) {
    onCancel() {
        const countryId = get(this.props.activePatient, 'countryId', '');
        const countrySettingsCountryId = get(this.props.countrySettings, 'countryId', '');
        if (countryId && countryId !== countrySettingsCountryId) {
            this.props.onFetchPatientCountryLocalization(countryId);
            this.props.onFetchPayers(countryId);
        }
        this.props.onCloseModal();
    }
    render() {
        if (!this.props.isHcpAccount) {
            return null;
        }
        return /*#__PURE__*/ _jsxs(Modal, {
            modalId: constants.INVITE_PATIENT_MODAL,
            openModalId: this.props.openModalId,
            styleModifier: "md",
            onClose: ()=>this.onCancel(),
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "modal__header",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.addNewPatient))
                }),
                /*#__PURE__*/ _jsx(AddPatientForm, {
                    modalId: constants.INVITE_PATIENT_MODAL,
                    onClose: this.props.onCloseModal
                })
            ]
        });
    }
}
_define_property(InvitePatientModal, "propTypes", {
    // Implicit props
    activePatient: PropTypes.shape({
        countryId: PropTypes.number.isRequired
    }),
    countrySettings: countrySettingsShape,
    isHcpAccount: PropTypes.bool,
    openModalId: PropTypes.string,
    // Implicit actions
    onFetchPatientCountryLocalization: PropTypes.func,
    onFetchPayers: PropTypes.func,
    onCloseModal: PropTypes.func
});
const mapStateToProps = (state)=>({
        activePatient: selectors.activePatient(state),
        countrySettings: selectors.countrySettings(state),
        isHcpAccount: Account.selectors.isHcpAccount(state),
        openModalId: App.selectors.modal(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onFetchPatientCountryLocalization: (countryId)=>dispatch(actions.fetchPatientCountryLocalization(countryId)),
        onFetchPayers: (countryId)=>dispatch(actions.fetchPayers(countryId)),
        onCloseModal: ()=>dispatch(App.actions.closeModal())
    });
const ConnectedInvitePatientModal = connect(mapStateToProps, mapDispatchToProps)(InvitePatientModal);
export default ConnectedInvitePatientModal;
